import React from "react";
import "./StatusCard.scss";
const StatusCard = props => {
  const {status} = props;
  const setClassName = status => {
    if (status == "Bình thường") {
      return "normal";
    } else if (status == "Gần hết hạn" || status == "Gần hết hàng") {
      return "almost";
    } else if (status == "Hết hạn") {
      return "expired";
    } else if (status == "Hết") {
      return "null";
    }
  };
  return <div className={`${setClassName(status)} status-card`}>{status}</div>;
};
export default StatusCard;
